import React from 'react';
import ReactDOM from "react-dom";
import * as pt from 'prop-types';
import createReactClass from 'create-react-class';
import xtend from 'xtend';
import _ from 'underscore';
import Immutable from 'immutable';
import { DashboardModal } from "@uppy/react";
import { connect } from 'react-redux'

import ErrorBoundary from '../../../ErrorBoundary'
import ErrorFallback from '../../../ErrorBoundary/ErrorFallback.js';
import UploadStore from '../../../common/flux/stores/UploadStore.js';
import Asset from './Asset';
import LinkUpload from "../../../routes/media/LinkUpload.js";
import RestrictedComponent, { hasPermission } from '../../../lib/components/form/RestrictedComponent.js';
import schema from '../../../routes/permissions/schema.js';
import TestError from '../../../ErrorBoundary/TestError.js';
import ThumbnailModal from '../thumbnails/ThumbnailModal';

const noop = function () { };

function getStoreState() {
    return {
        eventUploads: UploadStore.getEventUploads(),
        globalUploads: UploadStore.getGlobalUploads(),
    };
}

var Assets = createReactClass({
    propTypes: {
        assets: pt.array.isRequired,
        getMiscAssets: pt.func
    },

    getDefaultProps: function () {
        return {
            getMiscAssets: noop
        };
    },

    getInitialState: function () {
        return {
            eventUploads: UploadStore.getEventUploads(),
            globalUploads: UploadStore.getGlobalUploads(),
            uppyVisible: false,
            thumbnailModalVisible: false
        };
    },

    componentWillMount: function () {
        UploadStore.addChangeListener(this.onChange);
    },
    componentDidUpdate: function () {
        if (
            document.getElementsByClassName("uppy-Dashboard-innerWrap").length
        ) {
            const innerDashboards = document.getElementsByClassName(
                "uppy-Dashboard-innerWrap"
            );
            Array.prototype.forEach.call(innerDashboards, (uppyEl) => {
                if (
                    !Array.prototype.some.call(uppyEl.children, function (
                        child
                    ) {
                        return child.id === "link-asset-upload";
                    }) &&
                    uppyEl.children.length < 10
                ) {
                    ReactDOM.render(
                        <LinkUpload
                            clientID={this.props.clientID}
                            eventID={this.props.event.eventID}
                            uppy={this.props.getUppy()}
                        />,
                        uppyEl
                    );
                }
            });
        }
    },

    componentWillUnmount: function () {
        UploadStore.removeChangeListener(this.onChange);
    },

    shouldComponentUpdate: function (nextProps, nextState) {
        if (
            this.props.mode != 'manage' &&
            this.props.mode != 'assign' &&
            this.props.mode != 'assign-fallback' &&
            this.props.mode != 'assign-slates'
        ) {
            var id = this.props.event.eventID;
            if (
                this.state.eventUploads.id ||
                nextState.eventUploads.id
            ) {
                // console.log('should update check:', this.state.eventUploads.id, nextState.eventUploads.id)
                return (
                    !Immutable.is(
                        this.state.eventUploads.id,
                        nextState.eventUploads.id
                    ) || !_.isEqual(this.props, nextProps)
                );
            }
        }

        return this.props !== nextProps || this.state !== nextState;
    },

    onChange: function () {
        this.setState(getStoreState());
    },

    toggleUpload: function (event) {
        event && event.preventDefault();
        this.setState({uppyVisible:true})
    },

    handleThumbnailAssign: function() {
        this.props.getMiscAssets({});
        this.setState({thumbnailModalVisible: true});
    },

    handleCloseThumbnailModal: function() {
        this.setState({thumbnailModalVisible: false});
    },

    getPublishedAssetID: function() {
        // Extract the published asset ID from the event's videoDownloadURI
        try {
            return this.props.event.videoDownloadURI.split('/').pop().split('.')[0];
        } catch (error) {
            console.warn('Could not extract published asset ID:', error);
            return null;
        }
    },

    render: function () {
        var { mode } = this.props;
        var isMisc =
            mode == "manage" ||
            mode == "assign" ||
            mode == "assign-fallback" ||
            mode == "assign-slates";
        if (mode == "event")
            return (
                <>
                    {eventAssets.call(this)}
                    <DashboardModal
                        uppy={this.props.getUppy()}
                        plugins={[]}
                        open={this.state.uppyVisible}
                        onRequestClose={() =>
                            this.setState({ uppyVisible: false })
                        }
                        closeModalOnClickOutside={true}
                        showProgressDetails={true}
                        hideUploadButton={false}
                        hideCancelButton={false}
                        hideProgressAfterFinish={false}
                        proudlyDisplayPoweredByUppy={false}
                    />
                    {this.state.thumbnailModalVisible && (
                        <ThumbnailModal 
                            show={this.state.thumbnailModalVisible}
                            onClose={this.handleCloseThumbnailModal}
                            event={this.props.event}
                            emitSnack={this.props.emitSnack}
                            miscAssets={this.props.miscAssets?.data || []}
                            clientID={this.props.clientID}
                            targetAssetID={this.getPublishedAssetID()}
                        />
                    )}
                </>
            );
        if (isMisc) return this.renderMiscellaneousAssets();
        return <div className="alert alert-warning">View Error</div>;
    },

    renderMiscellaneousAssets: function () {
        var rendered = [];

        if (this.state.globalUploads.size) {
            this.state.globalUploads.map(function (upload, index) {
                rendered.push(
                    <Asset
                        {...this.props}
                        key={"upload-" + upload.get("uid")}
                        asset={upload}
                        event={this.props.event}
                        mode={this.props.mode}
                        kind="upload"
                    />
                );
            }, this);
        }

        if (this.props.assets) {
            for (var i = 0; i < this.props.assets.length; i++) {
                var asset = this.props.assets[i];
                var eventProps =
                    this.props.mode == "assign"
                        ? {
                            assignToEvent: this.props.assignToEvent.bind(
                                null,
                                asset
                            ),
                        }
                        : null;
                if (
                    (asset.name || "").toLowerCase().indexOf(this.props.term) >=
                    0
                ) {
                    var show = true;
                    if (this.props.filter && asset.type != this.props.filter)
                        show = false;

                    // If it's going to be assigned as a fallback image,
                    // it must be an image type asset.
                    if (
                        this.props.mode == "assign-fallback" &&
                        asset.type != "image"
                    )
                        show = false;

                    if (this.props.mode == "assign-slates") {
                        if (asset.type != this.props.slatesMode) show = false;
                    }

                    if (show) {
                        rendered.push(
                            <Asset
                                {...this.props}
                                {...eventProps}
                                kind="miscellaneous"
                                key={"asset-" + asset.assetID + "-" + i}
                                asset={asset}
                            />
                        );
                    }
                }
            }
        }

        return <div>{rendered}</div>;
    }
});

function assetElmt(asset, props) {
    var _props = {
        key: asset.assetID,
        asset: asset,
        emitSnack: this.props.emitSnack,
        event: this.props.event,
        mode: this.props.mode,
        actions: this.props.actions,
        getMiscAssets: this.props.getMiscAssets,
        miscAssets: this.props.miscAssets,
        clientID: this.props.clientID,
        disabled: (_(this.props.requests.events.resolving).findWhere({
            eventID: this.props.event.eventID
        }) || _(this.props.assets).findWhere({
            currentStatus: 'publishing'
        }))
    };

    return <Asset {...xtend(_props, props)} />;
}

function eventAssets() {
    var existing = this.props.event.mediaAssets;
    var uploads = this.state.eventUploads[this.props.event.eventID]

    var assets =
      existing &&
      existing
        .map(function (asset) {
          return assetElmt.call(this, asset, { kind: 'existing' })
        }, this)
        .concat(
          (uploads || []).map(function (upload) {
            return assetElmt.call(this, upload, {
              kind: 'upload',
              key: 'upload-' + upload.uid,
            })
          }, this)
        )

    var assignMiscButton = (
        <RestrictedComponent permissionCheck={schema.MANAGE_CLIENT_GLOBAL_MEDIA.READ}>
            <button className="btn btn-primary" onClick={this.props.toggleMiscAssignModal}>
                <i className="fa fa-cloud-download" /> Add from Media Library
            </button>
        </RestrictedComponent>
    );

    const assignThumbnailButton = this.props.event.eventStatus === 'published' ? (
        <RestrictedComponent permissionCheck={schema.EVENT_TAB_ASSETS.ASSET_SET_THUMBNAIL}>
            <button className="btn btn-primary" onClick={this.handleThumbnailAssign}>
                <i className="fa fa-camera" /> Assign Thumbnail
            </button>
        </RestrictedComponent>
    ) : null;

    const UploadButton = <div className="btn-group">
        <RestrictedComponent permissionCheck={schema.EVENT_TAB_ASSETS.CREATE}>
            <button className="btn btn-primary"
                onClick={this.toggleUpload}
            >
                <i className="fa fa-upload" /> Upload
            </button>
        </RestrictedComponent>
        {assignMiscButton}
        {assignThumbnailButton}
    </div>

    if (!assets || !assets.length) return (
      <ErrorBoundary FallbackComponent={ErrorFallback}>
        <div className='alert alert-info'>
          <p>
            <strong>Notice:</strong> No Media has been <em>Recorded</em> or{' '}
            <em>Uploaded</em> for this Event.
          </p>
          <hr />
          {UploadButton}
        </div>
      </ErrorBoundary>
    )

    if(hasPermission("event_tab_assets.read")) {
        return (
          <ErrorBoundary FallbackComponent={ErrorFallback}>
            <div className='asset-listing clearfix callout'>
              {UploadButton}
              <div className='row'>{assets}</div>
            </div>
          </ErrorBoundary>
        )
    }
    return <div>
        You do not have permission to view this tab
    </div>
}

const mapStateToProps = state => {
    const globalAssets = {}
    const eventAssets = {}
    return { globalAssets, eventAssets }
}

export default connect(mapStateToProps)(Assets);
